import script from "./SkewedDiv.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedDiv.vue?vue&type=script&setup=true&lang=js"

import "./SkewedDiv.vue?vue&type=style&index=0&id=1ca20c6a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca20c6a"]])

export default __exports__